import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from '@angular/forms';
import {FormAction} from '@shared/module/forms/model';

@Component({
  selector: 'app-form-input-password-confirm-password',
  templateUrl: './form-input-password-confirm-password.component.html',
  styleUrls: ['./form-input-password-confirm-password.component.scss']
})
export class FormInputPasswordConfirmPasswordComponent implements OnInit, OnChanges {
  @Input() formGroup!: FormGroup;
  @Input() direction?: String = 'row';
  @Input() formActionType!: FormAction;

  required: boolean = false;

  ngOnInit(): void {
    this.formGroup.setValidators(this.matchValidator('password', 'confirmPassword'));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.formActionType === FormAction.ADD) {
      this.required = true;
      this.formGroup.controls['password'].setValidators(Validators.required);
      this.formGroup.controls['confirmPassword'].setValidators(Validators.required);
    } else {
      this.required = false;
      this.formGroup.controls['password'].clearValidators();
      this.formGroup.controls['confirmPassword'].clearValidators();
      // On retire aussi les erreurs éventuelles
      this.formGroup.controls['password'].setErrors(null);
      this.formGroup.controls['confirmPassword'].setErrors(null);
    }
    this.formGroup.controls['password'].updateValueAndValidity();
    this.formGroup.controls['confirmPassword'].updateValueAndValidity();
  }

  matchValidator(source: string, target: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const sourceCtrl = control.get(source);
      const targetCtrl = control.get(target);

      if (sourceCtrl?.value !== '' && targetCtrl?.value === '') {
        return {requiredConfirm: true, mismatch: true};
      } else if (sourceCtrl?.value === '' && targetCtrl?.value !== '') {
        return {requiredPassword: true, mismatch: true};
      } else if (sourceCtrl?.value !== targetCtrl?.value) {
        return {mismatch: true};
      } else {
        return null;
      }
    };
  }

  get passwordMatchError() {
    if (this.formGroup.get('password')?.touched && this.formGroup.get('password')?.value !== '') {
      this.formGroup.controls['confirmPassword'].markAsTouched();
    }

    return (this.formGroup.getError('mismatch'));
  }

  get passwordRequireError() {
    return (this.formGroup.getError('requiredPassword'));
  }

  get confirmRequireError() {
    return (this.formGroup.getError('requiredConfirm'));
  }

}
